module.exports = __webpack_public_path__ + "fonts/SofiaProExtraLight-Italic.63f09a75.woff";